import { render, staticRenderFns } from "./editAreaType.vue?vue&type=template&id=55205e5c&scoped=true&"
import script from "./editAreaType.vue?vue&type=script&lang=ts&"
export * from "./editAreaType.vue?vue&type=script&lang=ts&"
import style0 from "./editAreaType.vue?vue&type=style&index=0&id=55205e5c&prod&lang=css&"
import style1 from "./editAreaType.vue?vue&type=style&index=1&id=55205e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55205e5c",
  null
  
)

export default component.exports